import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	triggerButton: {
		id: 'native-issue-table.common.issue-cells.cmdb-objects.trigger-button',
		defaultMessage: 'See more assets',
		description: 'Label for trigger button to open a dialog with a list of more CMDB object assets',
	},
});
